import { render } from "./ReviewPdfScript.vue?vue&type=template&id=f2e7c954"
import script from "./ReviewPdfScript.vue?vue&type=script&lang=js"
export * from "./ReviewPdfScript.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2845839839/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__